module.exports = __webpack_public_path__ + "img/photos-icon-disabled.0195fdd2.svg";